import Swiper, { Navigation } from "swiper";

const topicsCarousel = document.querySelectorAll(".regulatory-content-carousel__carousel");

topicsCarousel.forEach((slider, index) => {
  const Carousel = slider.querySelector(".swiper");
  const prevArrow = slider.querySelector(".prev");
  const nextArrow = slider.querySelector(".next");

  new Swiper(Carousel, {
    modules: [Navigation],
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
  });
});
